module.exports = "{{localize 'CORE.GRID.LOADINGROW.LOADING'}}";